import { ApolloClient, DefaultOptions, HttpLink, from } from '@apollo/client'
import { InMemoryCache } from '@apollo/client/cache'
import { onError } from '@apollo/client/link/error'

const createHttpLink = (uri: string) => {
  return new HttpLink({ uri })
}

const errorLink = onError(({ graphQLErrors, response }) => {
  if (graphQLErrors && response) {
    response.errors = undefined
  }
})

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }
}

export const clients = {
  'www-blue.sustainableFitch.com': new ApolloClient({
    // fetch: fetch as any,
    cache: new InMemoryCache(),
    defaultOptions,
    link: from([errorLink, createHttpLink('https://api-blue.fitchratings.com')])
  }),
  'www-green.sustainableFitch.com': new ApolloClient({
    // fetch: fetch as any,
    cache: new InMemoryCache(),
    defaultOptions,
    link: from([
      errorLink,
      createHttpLink('https://api-green.fitchratings.com')
    ])
  }),
  'www-qa-blue.sustainableFitch.com': new ApolloClient({
    // fetch: fetch as any,
    cache: new InMemoryCache(),
    defaultOptions,
    uri: 'https://api-qa-blue.fitchratings.com'
  }),
  'www-qa-green.sustainableFitch.com': new ApolloClient({
    // fetch: fetch as any,
    cache: new InMemoryCache(),
    defaultOptions,
    uri: 'https://api-qa-green.fitchratings.com'
  }),
  'www-qa.sustainableFitch.com': new ApolloClient({
    // fetch: fetch as any,
    cache: new InMemoryCache(),
    defaultOptions,
    uri: process.env.GATSBY_APOLLO
  }),
  'www-qa-1.sustainablefitch.com/': new ApolloClient({
    // fetch: fetch as any,
    cache: new InMemoryCache(),
    defaultOptions,
    uri: process.env.GATSBY_APOLLO
  }),
  'www-training.sustainableFitch.com': new ApolloClient({
    // fetch: fetch as any,
    cache: new InMemoryCache(),
    uri: process.env.GATSBY_APOLLO
  }),
  default: new ApolloClient({
    // fetch: fetch as any,
    cache: new InMemoryCache(),
    defaultOptions,
    link: from([errorLink, createHttpLink(process.env.GATSBY_APOLLO!)])
  })
}

export const fetchGqlData = async (query: any, variables: any = {}) => {
  if (query === undefined) {
    return null
  }
  const browser = typeof window !== 'undefined' && window
  if (browser) {
    const client = window.location.host
    const localClient = clients[client] ? clients[client] : clients.default
    return localClient.query({
      query,
      variables
    })
  }
  return null
}
